import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/template',
      name: 'template',
      component: () => import('@/views/TemplateViewer.vue'),
    },
    {
      path: '/template/admin',
      name: 'template-admin',
      component: () => import('@/views/TemplateAdmin.vue'),
    },
    {
      path: '/programs',
      name: 'programs',
      component: () => import('@/views/ProgramList.vue'),
    },
    {
      path: '/programs/:id',
      name: 'program-editor',
      component: () => import('@/views/ProgramEditor.vue'),
      props: true,
    },
    {
      path: '/audit',
      name: 'audit',
      component: () => import('@/views/AuditLog.vue'),
    },
  ],
})

export default router
